import { useFetch } from './useFetch'
import type { InventorySystemProfileToVenueDTO } from '../types'

export function useInventorySystemProfileToVenue(ispId: string, venueId: string) {
  const { data: mapping, isLoading, error } =
    useFetch<InventorySystemProfileToVenueDTO | null>(
      `/v1/inventory-system-profile-to-venues/${ispId}/${venueId}`,
      null
    )
  return { mapping, isLoading, error }
}
